import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../../redux';
import { authAxios } from '../../../lib/api';
import { useDebounce } from '../../../lib/useDebounce';
import '../../Components/dashboard.css';
import './index.css';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

function ManageUser(props) {
    const { history, forgotPassword, authErrCode, pending } = props;

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showUserDetails, setShowUserDetails] = useState(false);
    const [showPopover, setShowPopover] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const search = useDebounce(async () => {
        if (!searchQuery.trim() || searchQuery.length < 3) {
            setSearchResults([]);
            setShowPopover(false);
            return;
        }
        
        try {
            const results = await authAxios.post('/api/user/search', { query: searchQuery });
            if (results.data) {
                // filter admins out
                const filteredResults = results.data.filter(user => user.type !== 'admin');
                setSearchResults(filteredResults);
                setShowPopover(true);
            }
        } catch (error) {
            console.error('Error searching users:', error);
            setErrorMessage('Error searching users. Please try again.');
        }
    }, 500);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (searchQuery.length > 2) {
            search();
        }
    }, [searchQuery]);


    useEffect(() => {
        if (authErrCode && authErrCode.forgotPassword) {
            if (authErrCode.forgotPassword > 499) {
                setErrorMessage("Error sending password reset email. Please try again.");
            } else if (authErrCode.forgotPassword < 300) {
                setMessage(`Password reset email sent to ${selectedUser.email}`);
                setTimeout(() => setMessage(""), 5000);
            }
        }
    }, [authErrCode, pending]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setAnchorEl(e.currentTarget);
    };

    const handleUserSelect = (userId) => {
        const user = searchResults.find(user => user._id === userId);
        setSelectedUser(user);
        setShowUserDetails(true);
        setShowPopover(false);
        setSearchQuery('');
        setSearchResults([]);
    };

    const handleCloseUserDetails = () => {
        setShowUserDetails(false);
        setSelectedUser(null);
        setErrorMessage('');
        setMessage('');
    };

    const handleForgotPassword = () => {
        if (selectedUser && selectedUser.email) {
            setErrorMessage('');
            forgotPassword(selectedUser.email);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString();
    };

    const getRoleDisplayName = (type) => {
        switch (type) {
            case 'admin': return 'Administrator';
            case 'teacher': return 'Teacher';
            case 'student': return 'Student';
            default: return type;
        }
    };

    return (
        <div className="dashboard">
            <Link to="/admin" className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-" />
                Return to Dashboard
            </Link>
            
            <h3 style={{ marginTop: "50px", marginBottom: "24px" }}>User Management</h3>
            
            <div className="user-search-container">
                <TextField
                    name="searchQuery"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    hintText="Search users by name or email..."
                    fullWidth={true}
                    style={{ marginBottom: "20px" }}
                />
                
                {searchResults.length > 0 && (
                    <Popover 
                        open={showPopover} 
                        anchorEl={anchorEl} 
                        className="overlay-menu"
                        onRequestClose={() => setShowPopover(false)}
                    >
                        <Menu
                            disableAutoFocus
                            onChange={(e, i) => handleUserSelect(i)}
                        >
                            {searchResults.map((user) => (
                                <MenuItem
                                    key={user._id}
                                    value={user._id}
                                    primaryText={`${user.firstName} ${user.lastName} - (${user.email}) (${getRoleDisplayName(user.type)})`}
                                />
                            ))}
                        </Menu>
                    </Popover>
                )}
            </div>

            {selectedUser && (
                <Dialog
                    open={showUserDetails}
                    onRequestClose={handleCloseUserDetails}
                    contentStyle={{ maxWidth: '600px' }}
                >
                    <div style={{ padding: '20px' }}>
                        <h2 style={{ marginTop: '0', marginBottom: '20px', color: '#333' }}>
                            User Details
                        </h2>
                        
                        <div className="user-details">
                            <div className="user-detail-row">
                                <strong>Name:</strong> {selectedUser.firstName} {selectedUser.lastName}
                            </div>
                            <div className="user-detail-row">
                                <strong>Email:</strong> {selectedUser.email}
                            </div>
                            <div className="user-detail-row">
                                <strong>Role:</strong> {getRoleDisplayName(selectedUser.type)}
                            </div>
                            {selectedUser.studentId && (
                                <div className="user-detail-row">
                                    <strong>Student ID:</strong> {selectedUser.studentId}
                                </div>
                            )}
                            <div className="user-detail-row">
                                <strong>User ID:</strong> {selectedUser._id}
                            </div>
                            {selectedUser.school && (
                                <div className="user-detail-row">
                                    <strong>School ID:</strong> {selectedUser.school}
                                </div>
                            )}
                            {selectedUser.classes && selectedUser.classes.length > 0 && (
                                <div className="user-detail-row">
                                    <strong>Classes:</strong> {selectedUser.classes.length} class(es)
                                </div>
                            )}
                        </div>

                        {message && (
                            <div className="message" style={{ 
                                padding: "10px", 
                                marginBottom: "20px", 
                                backgroundColor: "#e8f5e8", 
                                border: "1px solid #4caf50", 
                                borderRadius: "4px",
                                color: "#2e7d32"
                            }}>
                                {message}
                            </div>
                        )}

                        {errorMessage && (

                            <div className="message" style={{ 
                                padding: "10px", 
                                marginBottom: "20px", 
                                backgroundColor: "#f8e8e8", 
                                border: "1px solid #f44336", 
                                borderRadius: "4px", 
                                color: "#b71c1c"
                            }}>
                                {errorMessage}
                            </div>
                        )}

                        <div className="user-actions" style={{ 
                            marginTop: '30px', 
                            display: 'flex', 
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <FlatButton 
                                label="Send Password Reset"
                                primary={true}
                                onClick={handleForgotPassword}
                                style={{ marginRight: '10px' }}
                                disabled={pending === 'forgotPassword'}
                            />
                            <FlatButton 
                                label="Close"
                                onClick={handleCloseUserDetails}
                            />
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}

export default connect(state => state.root, { forgotPassword })(ManageUser);
